import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import Navbar from "../components/navbar"
import Menu from "../components/menu"
import TitleH1 from "../components/titleH1"
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import FormLicenceCompetition from "../components/formLicenceCompetition"
import calculCategorie from '../components/calculCategorie'
import Paypal from "../components/paypal";
import {RadioButton, RadioGroup} from "react-radio-buttons";
import VerticalLinearStepper from "../components/stepper";
import Text from "../components/text";
import MenuMember from "../components/menuMember";
import Swal from "sweetalert2";
import Margin from "../components/margin";
import FormLicenceSubbuteo from "../components/formLicenceSubbuteo";
import Button from "../components/button";
import VerticalAlign from "../components/verticalAlign";

const _calculateAge = (birthdate) => {
    var ageDifMs = Date.now() - birthdate.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

const CreateLicence = props => {
    const [admin, setAdmin] = useState((localStorage.getItem('admin') === 'true'))
    const [data, setData] = useState({validite: (new Date().getFullYear()).toString()})
    const [clubs, setClubs] = useState([])
    const [selectedClub, setSelectedClub] = useState({})
    const [categorieState, setCategorie] = useState('AUCUNE')
    const [licenceType, setLicenceType] = useState("competition")
    const [totalPrice, setTotalPrice] = useState(0)
    const history = useHistory()

    const handleChange = async event => {
        if (event.target.name === "dateNaissance") {
            const categorie = calculCategorie(event.target.value)
            setCategorie(categorie)
            setData({...data, categorie, [event.target.name]: event.target.value})
        } else setData({...data, [event.target.name]: event.target.value})
    }

    const handleChangeRadio = event => {
        setLicenceType(event)
        setData({...data, typeLicence: event, idClub: 'none'})
    }

    const handleSubmit = async event => {
        event.preventDefault()
        if(event.target.name === "renew-nopay") {
            data.validite = "0"
        }
        if (await props.actions.licence.create(data))
            Swal.fire(
                'Bravo !',
                'Création de la licence réussie !',
                'success'
            ).then(() => {
                history.push('/')
            })
    }

    const dispatchLicenceData = async () => {
        if (!await props.actions.licence.dispatchLicences(data)) {
            alert("Impossible de récupérer les informations des licences. Veuillez rafraichir la page...")
        }
    }

    useEffect(() => {
        props.actions.club.getAllClubs()
            .then(res => setClubs(res.clubs))
            .catch(err => console.log(err))
    }, [props.actions])

    useEffect(() => {
        if (licenceType === "competition") {
            setTotalPrice((categorieState === "OPEN" || categorieState === "VETERAN") ? 35 : 20)
        } else {
            setTotalPrice(10)
        }
    }, [categorieState, licenceType])

    useEffect(() => {
        setAdmin((localStorage.getItem('admin') === 'true'))
        setSelectedClub(clubs.filter(club => club._id === data.idClub))
    }, [clubs, data])

    useEffect(() => {
        props.actions.licence.nextLicenceNumber(licenceType)
            .then(res => setData(previousDataState => ({...previousDataState, numeroLicence: res})))
            .catch(err => console.log(err))
    }, [licenceType, props.actions.licence])

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return <RadioGroup onChange={handleChangeRadio} name="typeLicence" horizontal>
                    <RadioButton value="competition" rootColor="#4466ca" pointColor={"#171d45"}>
                        <div id="competition">Compétition</div>
                    </RadioButton>
                    <RadioButton value="subbuteo" rootColor="#4466ca" pointColor={"#171d45"}>
                        <div id="subbuteo">Subbuteo</div>
                    </RadioButton>
                </RadioGroup>
            case 1:
                switch (licenceType) {
                    default:
                        return <FormLicenceCompetition handleChange={handleChange} clubs={clubs}
                                                       categorie={categorieState} admin={admin} data={data}
                                                       handleSubmit={handleSubmit}/>
                    case 'subbuteo':
                        return <FormLicenceSubbuteo handleChange={handleChange}
                                                    categorie={categorieState} admin={admin} data={data}
                                                    handleSubmit={handleSubmit}/>
                }
            case 2:
                return <>
                    <Text size="22px"><b>{data.prenom} {data.nom}</b>, {_calculateAge(new Date(data.dateNaissance))} ans</Text>
                    <Text>
                        {data.categorie}, {data.idClub === "none" ? 'Licence individuelle' : null}
                        {selectedClub.length > 0 && "nom" in selectedClub[0] ? selectedClub[0].nom : null}
                    </Text>
                    <Text>{data.adresse}, {data.codePostal} {data.ville} - {data.pays}</Text>
                    <Text size="22px">
                        Prix de la
                        licence {data.typeLicence} : <b>{totalPrice} €</b>
                    </Text>
                </>
            case 3:
                return (
                    <>
                        <Text size="22px">Plusieurs moyens de paiement :</Text>
                        <VerticalAlign>
                            <Paypal
                                name={`${data.prenom} ${data.nom} - ${categorieState}`}
                                total={totalPrice}
                                description={`Licence pour ${data.prenom} ${data.nom} - ${new Date().getFullYear()}`}
                                destination="/"
                                onSuccess={async () => await props.actions.licence.create(data)}
                            />
                            {
                                admin ?
                                    <>
                                        <p> -- OU --</p>
                                        <Button inverted={true}
                                                value="Sauter le paiement et renouveler"
                                                onClick={handleSubmit}
                                                marginTop="0"
                                                name="renew-nopay"/>
                                    </>
                                    : null
                            }
                        </VerticalAlign>
                    </>
                )
            default:
                return 'Etape inconnue';
        }
    }

    return (
        <div>
            <Navbar/>
            {(localStorage.getItem('admin') === 'true') ? <Menu/> : <MenuMember/>}
            <TitleH1 content="Créer une licence" margin="25px 0"/>
            <div>
                La licence <u>Compétition</u> vous permet de participer à n'importe quel tournoi national et/ou
                international pendant 1 an.<br/>
                La licence <u>Subbuteo</u> coûte 10€ et vous permet de participer à 1 tournoi national dans l'année.
            </div>
            <Margin marginBottom="50px"/>
            <VerticalLinearStepper getStepContent={getStepContent} dispatch={dispatchLicenceData}/>
        </div>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateLicence)
